<template>
  <div class="login-section">
    <div class="login-form__title">
      Reset Password
    </div>
    <div class="login__error-message">
      {{ error }}
    </div>
    <div class="reset-password__container">
      Enter your new password.
    </div>
    <div class="reset-password__container">
      <password-field
        :password.sync="password"
        :placeholder="'New Password'"
      />
      <password-validation
        :password="password"
        :is-valid.sync="isValidPassword"
      />
    </div>
    <div class="reset-password__container">
      <template v-if="loading">
        <loader :size="25" />
      </template>
      <template v-else>
        <button
          id="reset-password-button"
          class="btn btn-primary--green"
          :disabled="!isValidPassword"
          @click="emitResetPassword"
        >
          Reset Password
        </button>
      </template>
    </div>
    <div class="reset-password__footer">
      <span
        id="return-login"
        class="login__link"
        @click="toLoginScreen"
      > Back to Sign In </span>
    </div>
  </div>
</template>

<script>
import PasswordValidation from '@/components/passwordValidation.vue'
import PasswordField from '@/components/passwordField'
import Loader from '@/components/loader'

export default {
  name: 'ResetPassword',
  components: {
    passwordField: PasswordField,
    loader: Loader,
    PasswordValidation,
  },
  props: ['resetToken', 'loading', 'error'],
  data() {
    return {
      isValidPassword: false,
      password: '',
    }
  },
  methods: {
    toLoginScreen() {
      this.$emit('navigate-login')
    },
    emitResetPassword() {
      this.$emit('reset-password', this.password, this.resetToken)
    },
  },
}
</script>
